import { createGraphiQLFetcher } from "@graphiql/toolkit";
import GraphiQL from "graphiql";
import "graphiql/graphiql.min.css";
import "./app.css";

const fetcher = createGraphiQLFetcher({
  url: `http://${window.location.host}/graphql`,
  subscriptionUrl: `ws://${window.location.host}/graphql`,
});

export default function App() {
  return <GraphiQL fetcher={fetcher} />;
}
